export default "__VITE_ASSET__98241c7e__"